module.exports = __webpack_public_path__ + "img/banner.e0a47183.png";